// extracted by mini-css-extract-plugin
export var alignCenter = "_88-d";
export var bannerShown = "_88-6";
export var buttonContent = "_88-0";
export var cardList = "_88-1";
export var centerContent = "_88-2";
export var chevron = "_88-3";
export var closePanelButton = "_88-k";
export var conversationContextContainer = "_88-l";
export var conversationDetailContainer = "_88-4";
export var detailWrapper = "_88-7";
export var dropdownButton = "_88-e";
export var dropdownTitle = "_88-9";
export var fullHeight = "_88-5";
export var hidden = "_88-a";
export var icon = "_88-b";
export var mergeSuggestionWrapper = "_88-m";
export var panel = "_88-i";
export var portalButtonsWrapper = "_88-c";
export var right = "_88-j";
export var tableSummaryContainer = "_88-8";
export var tableSummaryHeader = "_88-g";
export var threeDotsButton = "_88-f";
export var wide = "_88-h";